import React from 'react';
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import DataTable from "../components/features/dashboard/employee-dashboard";
import BasicTable from "../components/features/dashboard/employee-dashboard";
import Error404 from "../components/shared/error/error-404";
import Error500 from "../components/shared/error/error-500";

import AdminDashboard from "../components/features/dashboard/index";

import Login2 from "../components/features/auth/login/login-2";
import Login3 from "../components/features/auth/login/login-3";
import ResetPassword2 from "../components/features/auth/resetPassword/resetPassword-2";
import TwoStepVerification2 from "../components/features/auth/twoStepVerification/twoStepVerification-2";
import ForgotPassword2 from "../components/features/auth/forgotPassword/forgotPassword-2";
import ResetPasswordSuccess2 from "../components/features/auth/resetPasswordSuccess/resetPasswordSuccess-2";

import Profile from "../components/features/profile";
import EmployeeDashboard from "../components/features/dashboard/employee-dashboard";
import AttendanceReport from "../components/features/reports/attendance-report";

import EmployeeList from "../components/features/employees/employeesList";
import Department from "../components/features/employees/deparment";

import Branch from '../components/features/branch/branch';
import LeaveEmployee2 from '../components/features/leaves/pages/leaveEmployee2';
import LeaveAdmin2 from '../components/features/leaves/pages/leaveAdmin2';
import EmployeeDetails from '../components/features/employees/employeedetails';
import TicketsAdmin from '../components/features/tickets/ticketsAdmin';
import TicketsEmployee from '../components/features/tickets/ticketsEmployee';
import Shift from '../components/features/shift/shift';
import BreakReport from '../components/features/reports/breakReport';
import AttendanceReports from '../components/features/reports/attendanceReport';
import CompanySettings from '../components/features/settings/CompanySettings';
import EmployeeReport from '../components/features/reports/employee-report';
import LeaveReport from '../components/features/reports/leave-report';
import ShiftReport from '../components/features/reports/shift-report';
import TicketReport from '../components/features/reports/ticket-report';
import Notification from '../components/features/notification/notification';
import AllAttendanceUser from '../components/features/employees/components/allEmployeePage/allAttendanceUse';
import AllLeaveUser from '../components/features/employees/components/allEmployeePage/allLeaveUser';
import AllTicketsUser from '../components/features/employees/components/allEmployeePage/allTicketsUser';
import AllNotification from '../components/features/notification/allNotification';
import CompanyDetails from '../components/features/superadmin/companyDetails';
import CreateCompany from '../components/features/superadmin/createCompany';
import AllCompanies from '../components/features/superadmin/allCompanies';
import { PermissionType } from '../types/user.types';
import AboutUs from '../components/features/superadmin/aboutUs';
import EditCompany from '../components/features/superadmin/editCompany';
import SuperAdminDashboard from '../components/features/superadmin/superAdminDashboard';
import AllBreakUser from '../components/features/employees/components/allEmployeePage/allBreakUser';
import ForgottenCheckouts from '../components/features/employees/forgottenCheckouts';
import ForgottenCheckIn from '../components/features/employees/forgottenCheckIn';
import PricingPage from '../components/features/pricing/pricing';
import CouponsPage from '../components/features/superadmin/coupon/coupons';
import CreateCouponPage from '../components/features/superadmin/coupon/createCoupon';
import EditCouponPage from '../components/features/superadmin/coupon/editCoupon';
import CouponDetailsPage from '../components/features/superadmin/coupon/couponDetails';
import PaymentReportsPage from '../components/features/superadmin/paymentReports';
import ProductManagement from '../components/features/superadmin/ProductManagement';
import PaymentCallback from '../components/features/subscription/PaymentCallback';
import SubscriptionCallback from '../components/features/subscription/SubscriptionCallback';
import DocumentsPage from '../components/features/reports/documents';
import AssetsPage from '../components/features/assets/assets';
const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.superAdminCompanyDetails,
    element: <CompanyDetails />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.superAdminAboutUs,
    element: <AboutUs />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.superAdminCompanyEdit,
    element: <EditCompany />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.superAdminCompanyCreate,
    element: <CreateCompany />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.superAdminCompanies,
    element: <AllCompanies />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.superAdminDashboard2,
    element: <SuperAdminDashboard />,
    route: Route,
    roles:[PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
    roles:[PermissionType.CONTROL_PANEL_ADMIN]
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />,
    route: Route,
    roles:[PermissionType.CONTROL_PANEL_USER]
  },
  {
    path: routes.branches,
    element: <Branch />,
    roles:[PermissionType.VIEW_BRANCHES]
  },
  {
    path: routes.shift,
    element: <Shift />,
    roles:[PermissionType.MANAGE_SHIFTS]
  },
  {
    path: routes.forgotCheckOut,
    element: <ForgottenCheckouts />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.forgotCheckIn,
    element: <ForgottenCheckIn />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  { 
    path: routes.attendanceReport,
    element: <AttendanceReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.notificationList,
    element: <AllNotification />,
    roles:[PermissionType.CREATE_NOTIFICATIONS]
  },
  {
    path: routes.attendance,
    element: <AttendanceReports />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.breakReport,
    element: <BreakReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.companySettings,
    element: <CompanySettings />,
    roles:[PermissionType.COMPANY]
  },
  {
    path: routes.employeeReport,
    element: <EmployeeReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.shiftReport,
    element: <ShiftReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.ticketReport,
    element: <TicketReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },
  {
    path: routes.notification,
    element: <Notification />,
    roles:[PermissionType.CREATE_NOTIFICATIONS]
  },
  {
    path: routes.userAttendance,
    element: <AllAttendanceUser />,
    roles:[PermissionType.VIEW_USERS]
  },
  {
    path: routes.userBreak,
    element: <AllBreakUser />,
    roles:[PermissionType.VIEW_USERS]
  },
  {
    path: routes.userLeaves,
    element: <AllLeaveUser />,
    roles:[PermissionType.VIEW_LEAVE]
  },
  {
    path: routes.userTickets,
    element: <AllTicketsUser />,
    roles:[PermissionType.VIEW_TICKETS_ADMIN]
  },
  //Application

  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
  },


  {
    path: routes.ticketAdmin,
    element: <TicketsAdmin />,
    route: Route,
    roles:[PermissionType.VIEW_TICKETS_ADMIN]
  },
  {
    path: routes.ticketEmployee,
    element: <TicketsEmployee />,
    route: Route,
    roles:[PermissionType.VIEW_TICKETS_USER]
  },


  {
    path: routes.profile,
    element: <Profile />,
    roles: [PermissionType.CONTROL_PANEL_USER, PermissionType.CONTROL_PANEL_ADMIN]
  },
  
  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    roles: [PermissionType.VIEW_USERS]
  },
  {
    path: routes.leaveReport,
    element: <LeaveReport />,
    roles:[PermissionType.VIEW_REPORTS]
  },


  {
    path: routes.employeeList,
    element: <EmployeeList />,
    route: Route,
    roles:[PermissionType.VIEW_USERS]
  },
  {
    path: routes.departments,
    element: <Department />,
    route: Route,
    roles:[PermissionType.VIEW_DEPARTMENTS]
  },
  {
    path: routes.leaveadmin,
    element: <LeaveAdmin2 />,
    route: Route,
    roles:[PermissionType.VIEW_LEAVE]
  },
  {
    path: routes.leaveemployee,
    element: <LeaveEmployee2 />,
    route: Route,
    roles:[PermissionType.LEAVE_REQUEST]
  },
  {
    path: routes.employeedetails,
    element: <EmployeeDetails />,
    roles: [PermissionType.VIEW_USERS]
  },
  {
    path: routes.pricing,
    element: <PricingPage />,
    route: Route,
    roles: [PermissionType.PRICING_ACCESS]
  },
  {
    path: routes.coupons,
    element: <CouponsPage />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.createCoupon,
    element: <CreateCouponPage />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.editCoupon,
    element: <EditCouponPage />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.couponDetails,
    element: <CouponDetailsPage />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.paymentReports,
    element: <PaymentReportsPage />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.productManagement,
    element: <ProductManagement />,
    route: Route,
    roles: [PermissionType.MANAGE_COMPANY]
  },
  {
    path: routes.documents,
    element: <DocumentsPage />,
    route: Route,
    roles: [PermissionType.FILE_VIEW]
  },
  {
    path: routes.subscriptionCallback,
    element: <SubscriptionCallback />,
    route: Route,
    roles: [PermissionType.COMPANY, PermissionType.PRICING_ACCESS]
  },
  {
    path: routes.assets,
    element: <AssetsPage />,
    route: Route,
    roles: [PermissionType.VIEW_ASSETS]
  },

];

export const authRoutes = [

  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.createCompany,
    element: <Login3 />,
    route: Route,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },
  {
    path: routes.paymentCallback,
    element: <PaymentCallback />,
    route: Route,
    // roles: [PermissionType.PRICING_ACCESS] // Ödeme yapabilen herkes callback sayfasını görebilir
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },

  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
];
